import { SxProps, Theme } from '@mui/material';

export const AATooltipButtonSX: SxProps<Theme> = {
	justifyContent: 'flex-end',
	'&:hover': {
		border: 'none',
	},
	pr: 0,
};

export const AATooltipButtonTopRightSX: SxProps<Theme> = {
	...AATooltipButtonSX,
	p: 0,
	width: 'auto',
	height: 'auto',
};

export const AAFieldTooltipSX: SxProps<Theme> = (theme) => ({
	backgroundColor: 'grey.50',
	color: 'grey.500',
	borderRadius: 0,
	boxShadow: 'none',
	width: '100px',
	borderTop: `2px solid ${theme.palette.primary.main}`,
	pr: 0,
	zIndex: '99999999',
});

export const AAFieldPopperSX: SxProps<Theme> = () => ({
	zIndex: '99999999',
});
